// tracking/tracker.js

/**
 * 解析目前網址中的 _ads 參數
 * - 特別處理 /g 路徑
 * - 其他路徑則正常取 _ads 參數
* - 追加 &ref=document.referrer* 
 */
export function parseCurrentUriAds() {
  try {
    const url = new URL(window.location.href);
    const ref = document.referrer || null;

    let ads = null;

    // /g 路徑
    if (url.pathname === "/g") {
      const raw = url.search.substring(1);
      if (raw) {
        const first = raw.split("&")[0]; // e.g. "_ads=123"
        if (first.startsWith("_ads=")) {
          ads = first.split("=")[1] || null;
        }
      }
    } else {
      ads = url.searchParams.get("_ads");
    }

    return { ads, ref };

  } catch (error) {
    console.error("Error parsing URL:", error);
    return { ads: null, ref: null };
  }
}

/**
 * 將按鈕點擊資訊送到後端紀錄
 * - 優先取 href 中的 _ads 當作 button_text
 * - 沒有則 fallback 為按鈕文字內容，再退而取 <img alt>，最後為 unknown
 */
export function trackButtonClick(buttonElement) {
  const url = new URL(buttonElement.href);
  const adsParam = url.searchParams.get("_ads");

  // 建立 buttonText fallback 邏輯
  let buttonText = adsParam;
  if (!buttonText) {
    const textContent = buttonElement.textContent.trim();
    if (textContent) {
      buttonText = textContent;
    } else {
      const img = buttonElement.querySelector("img");
      buttonText = img?.alt?.trim() || "unknown";
    }
  }

  const clickData = {
    page_url: buttonElement.href,
    button_id: buttonElement.id,
    button_text: buttonText,
    button_class: buttonElement.className,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
  };

  fetch("https://api.bwd.tw/click/record", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(clickData),
  }).catch((err) => {
    console.error("Failed to send click data:", err);
  });
}
